import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class AssetActionControlRequest {
    @ApiProperty()
    @IsNotEmpty()
    assetCode: string;
    @ApiProperty()
    @IsNotEmpty()
    tubCode: string;
    @ApiProperty()
    @IsNotEmpty()
    durationOne: number;
    @ApiProperty()
    @IsNotEmpty()
    durationTwo: number;
    @ApiProperty()
    @IsNotEmpty()
    createdUser: string;
    @ApiProperty()
    @IsNotEmpty()
    date: string;
    @ApiProperty()
    @IsNotEmpty()
    cronJobTime: string;
    @ApiProperty()
    @IsNotEmpty()
    jobId: string;
    @ApiProperty()
    @IsNotEmpty()
    assetControl:boolean;
    @ApiProperty()
    unitId:number;
}